import { render, staticRenderFns } from "./MedicineDetailsModal.vue?vue&type=template&id=573b8db2&scoped=true&"
import script from "./MedicineDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./MedicineDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineDetailsModal.vue?vue&type=style&index=0&id=573b8db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b8db2",
  null
  
)

export default component.exports